var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Broken/bag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.787 4.4248L10.1357 11.0945M28.5094 4.4248L35.1607 11.0945",
    stroke: "currentColor",
    strokeWidth: 2.75606,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.27454 15.1757C4.27454 11.7766 6.09353 11.501 8.3535 11.501H36.943C39.203 11.501 41.0219 11.7766 41.0219 15.1757C41.0219 19.1261 39.203 18.8505 36.943 18.8505H8.3535C6.09353 18.8505 4.27454 19.1261 4.27454 15.1757V15.1757Z",
    stroke: "currentColor",
    strokeWidth: 2.75606
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.5325 26.4725V32.9952M26.9844 26.4725V32.9952M9.62127 34.9979C10.2092 38.5624 11.624 41.1715 16.8789 41.1715H27.9582C33.6725 41.1715 34.5176 38.6727 35.1791 35.2184L38.2659 19.123M7.03058 19.123L8.35349 27.1707",
    stroke: "currentColor",
    strokeWidth: 2.75606,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.be2f3622eb157a7fab7b20165caccdce.svg";
export { ForwardRef as ReactComponent };